export function setDataToSessionStorage(key, value) {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch (err) {
    console.log('setDataToSessionStorage', err);
  }
}

export function getDataFromSessionStorage(key) {
  try {
    const data = sessionStorage.getItem(key);
    return JSON.parse(data);
  } catch (err) {
    console.log('getDataFromSessionStorage', err);
    return null;
  }
}

export function inIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}
